











import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { resolveRemainingCustomerCareWindow } from "@/utils/chats";
import customerCareClosed from "@/views/modules/messaging-inbox/alerts/components/customerCareClosed.vue";
import CustomerCareRemaining from "@/views/modules/messaging-inbox/alerts/components/customerCareRemaining.vue";
import MandatoryAssign from "@/views/modules/messaging-inbox/alerts/components/mandatoryAssign.vue";
import { CustomerCareWindow } from "@/views/modules/messaging-inbox/useChat";
import { computed, defineComponent } from "@vue/composition-api";
import { storeToRefs } from "pinia";

export default defineComponent({
    components: {
        MandatoryAssign,
        CustomerCareRemaining,
        customerCareClosed,
    },
    setup() {
        const { activeChat } = storeToRefs(useChatsStore());
        const { activeChatChannel } = storeToRefs(useChannelsStore());

        const customerCareWindow = computed((): CustomerCareWindow => {
            return resolveRemainingCustomerCareWindow(
                activeChat.value?.chat.lastInboundMessageTime,
                activeChatChannel.value?.customerCareWindowLength
            );
        });

        return {
            activeChatChannel,
            customerCareWindow,
        };
    },
});
